/* ============================================================
   THE HAIR HUT — theme interactions
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) =>
    (window.Shopify && Shopify.currency)
      ? formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);

  function formatMoney(cents) {
    const fmt = window.themeMoneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ----------  Sticky header shadow  ---------- */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ----------  Drawer controller  ---------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  }
  function show(drawer) {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) {
      openDrawer.classList.remove('is-open');
      openDrawer.setAttribute('inert', '');
    }
    openDrawer = drawer;
    drawer.classList.add('is-open');
    drawer.removeAttribute('inert');
    overlay && overlay.classList.add('is-open');
    lockScroll(true);
    const f = drawer.querySelector('[autofocus], button, a, input');
    f && setTimeout(() => f.focus(), 350);
  }
  function hide() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('inert', '');
    overlay && overlay.classList.remove('is-open');
    lockScroll(false);
    openDrawer = null;
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      show($('#' + opener.getAttribute('data-drawer-open')));
    }
    if (e.target.closest('[data-drawer-close]')) hide();
  });
  overlay && overlay.addEventListener('click', hide);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') hide(); });

  /* ----------  Mobile nav disclosure  ---------- */
  $$('.mobile-nav__btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      const sub = btn.parentElement.querySelector('.mobile-nav__sub');
      sub && sub.classList.toggle('is-open', !open);
    });
  });

  /* ----------  Accordions (FAQ / product)  ---------- */
  $$('.accordion__btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      const panel = btn.nextElementSibling;
      panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
    });
  });

  /* ----------  Reveal on scroll  ---------- */
  const reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* ----------  Marquee: duplicate track for seamless loop  ---------- */
  $$('.marquee__track').forEach((track) => {
    track.innerHTML += track.innerHTML;
  });

  /* ----------  Quantity steppers  ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    if (!input) return;
    const dir = parseInt(step.getAttribute('data-qty-step'), 10);
    const next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + dir);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----------  Product gallery thumbs  ---------- */
  const gallery = $('[data-gallery]');
  if (gallery) {
    const main = $('[data-gallery-main] img', gallery);
    $$('[data-gallery-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        const srcset = thumb.getAttribute('data-srcset');
        if (main && src) { main.src = src; if (srcset) main.srcset = srcset; }
        $$('[data-gallery-thumb]', gallery).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* ----------  Variant selection  ---------- */
  const productForm = $('[data-product-form]');
  if (productForm) {
    const dataEl = $('[data-product-json]');
    let product = null;
    try { product = JSON.parse(dataEl.textContent); } catch (e) {}

    const idInput = $('[name="id"]', productForm);
    const priceEl = $('[data-product-price]');
    const compareEl = $('[data-product-compare]');
    const addBtn = $('[data-add-btn]');

    function currentOptions() {
      return $$('[data-option-index]', productForm).map((group) => {
        const checked = group.querySelector('input:checked, option:checked');
        if (group.tagName === 'SELECT') return group.value;
        return checked ? checked.value : null;
      });
    }
    function matchVariant(opts) {
      if (!product) return null;
      return product.variants.find((v) =>
        v.options.every((o, i) => o === opts[i])
      );
    }
    function update() {
      const v = matchVariant(currentOptions());
      if (!v) {
        addBtn.disabled = true;
        addBtn.querySelector('[data-add-label]').textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      addBtn.disabled = !v.available;
      addBtn.querySelector('[data-add-label]').textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    productForm.addEventListener('change', (e) => {
      if (e.target.closest('[data-option-index]') || e.target.matches('[data-option-index]')) update();
    });
    update();
  }

  /* ----------  Cart (AJAX) + drawer  ---------- */
  const cartDrawer = $('#cart-drawer');
  const cartCounts = $$('[data-cart-count]');

  async function fetchCart() {
    const res = await fetch(window.Shopify ? '/cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }
  function setCount(n) {
    cartCounts.forEach((el) => { el.textContent = n; el.hidden = n < 1; });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    const body = $('[data-cart-body]', cartDrawer);
    const foot = $('[data-cart-foot]', cartDrawer);
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p class="lead">Your bag is empty.</p><a class="btn btn--outline mt-2" href="/collections/all" data-drawer-close>Shop products</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = '<ul class="cart-drawer__items">' + cart.items.map((it) => `
      <li class="cart-item" data-line-key="${it.key}">
        <a href="${it.url}" class="cart-item__img" data-drawer-close>${it.image ? `<img src="${it.image}" alt="" width="76" height="101" loading="lazy">` : ''}</a>
        <div>
          <a href="${it.url}" class="cart-item__title" data-drawer-close>${it.product_title}</a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${it.variant_title}</div>` : ''}
          <div class="cart-item__price">${money(it.final_price)}</div>
          <div class="qty" style="margin-top:8px">
            <button type="button" data-qty-cart="${it.key}" data-to="${it.quantity - 1}" aria-label="Decrease">&minus;</button>
            <input type="text" value="${it.quantity}" readonly>
            <button type="button" data-qty-cart="${it.key}" data-to="${it.quantity + 1}" aria-label="Increase">+</button>
          </div>
          <button class="cart-item__remove" data-qty-cart="${it.key}" data-to="0" type="button">Remove</button>
        </div>
        <div class="cart-item__price">${money(it.final_line_price)}</div>
      </li>`).join('') + '</ul>';
    const totalEl = $('[data-cart-total]', cartDrawer);
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  async function changeLine(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    const cart = await res.json();
    renderCart(cart);
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-cart]');
      if (btn) changeLine(btn.getAttribute('data-qty-cart'), parseInt(btn.getAttribute('data-to'), 10));
    });
  }

  // Add to cart via any [data-product-form] or quick-add buttons
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"], [data-add-btn]');
    const label = btn && btn.querySelector('[data-add-label]');
    const prev = label ? label.textContent : (btn ? btn.textContent : '');
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Adding…';
    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd });
      if (!res.ok) throw new Error('add failed');
      const cart = await fetchCart();
      renderCart(cart);
      show(cartDrawer);
    } catch (err) {
      toast('Something went wrong. Please try again.');
    } finally {
      if (btn) btn.disabled = false;
      if (label) label.textContent = prev;
    }
  });

  // Initial cart count hydrate
  if (cartCounts.length || cartDrawer) {
    fetchCart().then(renderCart).catch(() => {});
  }

  /* ----------  Toast  ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + msg + '</span>';
    requestAnimationFrame(() => toastEl.classList.add('is-show'));
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toastEl.classList.remove('is-show'), 2600);
  }
  window.themeToast = toast;

  /* ----------  Collection sort  ---------- */
  const sortSelect = $('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
